function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { v4 as uuid } from 'uuid';
import QRCode from 'qrcode.react';
import { motion } from 'framer-motion';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import debounce from 'lodash/debounce';
import findLast from 'lodash/findLast';
import get from 'lodash/get';
import find from 'lodash/find';
import forEach from 'lodash/forEach';
import map from 'lodash/map';
import includes from 'lodash/includes';
import keysIn from 'lodash/keysIn';
import pick from 'lodash/pick';
import startsWith from 'lodash/startsWith';
import isEmpty from 'lodash/isEmpty';
import history from 'helpers/history';
import { getSlug } from 'helpers/urlTools';
import { formatISODate } from 'helpers/datetime';
import { createValidatorRules } from 'helpers/templatedFields';
import { AppContext } from 'context';
import MetricConversions from 'libs/MetricConversions';
import Validator from 'libs/Validator';
import { foldObject, unfoldObject } from 'helpers/transformers';
import { addMetricUnitMaxValueRules } from 'helpers/patientProfileValidatorRules';
import TemplatedFields from 'components/TemplatedFields';
import FormContainerAbstract from 'components/FormContainerAbstract';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import CheckboxRadio from 'components/Form/CheckboxRadio';
import Input from 'components/Form/Input';
import AutosuggestInput from 'components/Form/AutosuggestInput';
import Button from 'components/Form/Button';
import Tabs from 'components/Tabs';
import DateOfBirthFormPartial from 'components/DateOfBirthFormPartial';
import PhiSetFormPartial from 'components/PhiSetFormPartial';
import countrySettingsShape from 'shapes/countrySettingsShape';
import informationFieldShape from 'shapes/informationFieldShape';
import intlShape from 'shapes/intlShape';
import ChevronRight from 'svg/chevron-right.svg';
import App, { AlertsBus } from 'modules/App';
import Account from 'modules/Account';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import * as shapes from '../../shapes';
import messages from '../../messages';
import styles from './AddPatientForm.pcss';
import validatorRules from './validatorRules.json';
class AddPatientForm extends FormContainerAbstract {
    static getDerivedStateFromProps(props, state) {
        const { isInProgress, hasErrors, isAutoActivation } = props;
        const { view } = state;
        if (isInProgress !== state.isInProgress && (isInProgress || hasErrors || view === 'qrCode' && !isAutoActivation)) {
            return {
                isInProgress
            };
        }
        return null;
    }
    componentDidUpdate(prevProps) {
        const { receivedSharingRequest, clinicPatientTemplate, modalId, openModalId, isInProgress, hasErrors } = this.props;
        if (openModalId !== modalId) {
            return;
        }
        if (prevProps.clinicPatientTemplate !== clinicPatientTemplate) {
            this.onSetupPersonalIdentifier();
        }
        if (receivedSharingRequest && receivedSharingRequest !== prevProps.receivedSharingRequest && receivedSharingRequest.sharingStatus === 'Enrolling') {
            const { sharingRequestId, patient } = receivedSharingRequest;
            const { organizationUID, name } = get(this.props.activeClinicMembership, 'clinic', {});
            const clinicSlug = getSlug(name);
            const patientSlug = getSlug(`${patient.firstName} ${patient.lastName}`);
            const patientId = `esr-${sharingRequestId}`;
            const url = this.context.getUrl('hcp-results', {
                clinicSlug,
                organizationUID,
                patientSlug,
                patientId
            });
            history.push(url);
            this.onClose();
        }
        if (prevProps.isInProgress !== isInProgress && !isInProgress && !hasErrors) {
            const { newPatient } = this;
            if (this.props.isAutoActivation || this.state.view === 'manual') {
                if (newPatient) {
                    const { organizationUID, name } = get(this.props.activeClinicMembership, 'clinic', {});
                    const clinicSlug = getSlug(name);
                    const patientSlug = getSlug(`${newPatient.firstName} ${newPatient.lastName}`);
                    const url = this.context.getUrl('hcp-results', {
                        clinicSlug,
                        organizationUID,
                        patientSlug,
                        patientId: newPatient.id
                    });
                    history.push(url);
                }
                this.onClose(newPatient);
            }
        }
    }
    componentWillUnmount() {
        this.onClose();
    }
    onAddValidatorRules(rules) {
        this.validatorRules = _object_spread({}, this.validatorRules, rules);
    }
    onSetupPersonalIdentifier() {
        const personalIdentifierTemplate = find(this.props.clinicPatientTemplate, {
            name: 'personalIdentifier'
        });
        if (!personalIdentifierTemplate) {
            this.props.onUnsetFormValues(this.personalIdentifierFields);
            this.validatorRules = pick(this.validatorRules, keysIn(this.validatorRules).filter((key)=>!startsWith(key, 'personalIdentifier')));
            return;
        }
        if (isEmpty(this.personalIdentifierFields)) {
            const personalIdentifierFields = [];
            forEach(personalIdentifierTemplate.fields, (f)=>personalIdentifierFields.push(`personalIdentifier.${f.name}`));
            this.personalIdentifierFields = personalIdentifierFields;
        }
        const personalIdentifierTypeTemplate = find(personalIdentifierTemplate.fields, {
            name: 'personalIdentifierType'
        });
        const personalIdentifierTypeOptions = map(get(personalIdentifierTypeTemplate, 'options'), (o)=>o.value);
        const { personalIdentifier } = unfoldObject(get(this.props.formValues, 'values', {}));
        if (!personalIdentifier || !includes(personalIdentifierTypeOptions, personalIdentifier.personalIdentifierType)) {
            const values = foldObject({
                personalIdentifierType: personalIdentifierTypeOptions[0],
                personalIdentifierValue: undefined
            }, 'personalIdentifier');
            this.props.onSetFormValues(values);
        }
    }
    onChangeView(view) {
        if (view === 'qrCode') {
            this.patientId = null;
            this.props.onUnsetReceivedSharingRequest();
            this.props.onCheckApprove(this.invitationCode, actions.setReceivedSharingRequest);
        } else {
            this.props.onStopCheckApprove();
        }
        this.setState({
            view
        });
    }
    onToggleOptionalSection(evt) {
        evt.stopPropagation();
        this.setState((state)=>({
                isOptionalSectionOpen: !state.isOptionalSectionOpen
            }));
    }
    onToggleOptionalSectionOverflow(trigger) {
        if (trigger === 'start' && this.state.isOptionalSectionOpen || trigger === 'complete' && !this.state.isOptionalSectionOpen) {
            this.setState((state)=>({
                    isOptionalSectionOverflow: !state.isOptionalSectionOverflow
                }));
        }
    }
    onClose(newPatient) {
        if (this.props.onClose) {
            this.props.onClose(newPatient);
        }
        this.props.onStopCheckApprove();
        this.props.onUnsetReceivedSharingRequest();
        this.props.onClearForm();
    }
    onSubmit() {
        this.props.onFormProcessing();
        const { validatedValues, errors } = this.onValidate(this.validatorRules);
        this.props.onFormErrors(errors);
        if (!errors) {
            this.patientId = uuid();
            validatedValues.id = this.patientId;
            validatedValues.dataType = 'BGM';
            const { weight, height, payer } = validatedValues;
            validatedValues.weight = weight && this.metricConversions.weight.toStorage(weight);
            validatedValues.height = height && this.metricConversions.height.toStorage(height);
            this.props.onSubmit(unfoldObject(validatedValues), this.props.activeClinicMembership);
            if (payer) {
                const countryId = get(this.props.activeClinicMembership, 'clinic.countryId');
                this.props.onAddPayerProposal(countryId, payer);
            }
        }
    }
    onValidate(rules) {
        const values = _object_spread({}, get(this.props.formValues, 'values', {}));
        const { dateOfBirth, sendEmailInvitation } = values;
        if (dateOfBirth && dateOfBirth.year && dateOfBirth.month && dateOfBirth.day) {
            values.dateOfBirth = formatISODate(new Date(Date.UTC(dateOfBirth.year, dateOfBirth.month - 1, dateOfBirth.day)), true);
        } else {
            values.dateOfBirth = '';
        }
        const clonedRules = _object_spread({}, rules);
        if (sendEmailInvitation) {
            clonedRules.email = 'required, email';
        }
        clonedRules.payer = this.isTemplateFieldHidden('payer') ? 'trim' : createValidatorRules(this.findTemplateFieldByName('payer')).payer;
        return Validator.run(values, clonedRules);
    }
    onChangeName(input) {
        this.props.onSetFormValue(input);
        this.onDebouncedEnterName();
    }
    onEnterName() {
        const { firstName, lastName } = get(this.props.formValues, 'values', {});
        const otherPatient = firstName && lastName && find(this.props.patients, {
            firstName,
            lastName
        });
        this.requiredRules = {};
        this.validatorRules.dateOfBirth = otherPatient ? 'required' : '*';
        const isDateOfBirthMandatory = !!otherPatient;
        this.setState((state)=>{
            if (state.isDateOfBirthMandatory === isDateOfBirthMandatory) {
                return null;
            }
            return {
                isDateOfBirthMandatory
            };
        });
    }
    get newPatient() {
        const { patients } = this.props;
        return findLast(patients, {
            id: this.patientId
        });
    }
    get isDateOfBirthMandatory() {
        return this.state.isDateOfBirthMandatory;
    }
    get isDisabled() {
        const { isFetchPatientCountryLocalizationInProgress, hasFetchPatientCountryLocalizationError } = this.props;
        const { errors } = this.onValidate(this.requiredRules);
        return !!errors || isFetchPatientCountryLocalizationInProgress || hasFetchPatientCountryLocalizationError;
    }
    isTemplateFieldHidden(fieldName) {
        return !this.findTemplateFieldByName(fieldName);
    }
    findTemplateFieldByName(informationName) {
        return find(this.props.clinicPatientTemplate, (information)=>information.name === informationName);
    }
    renderEmailField() {
        const isSendEmailInvitation = get(this.props.formValues, 'values.sendEmailInvitation', false);
        if (!isSendEmailInvitation) {
            return null;
        }
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: "email",
            labelMessage: messages.labels.email,
            formValues: this.props.formValues,
            children: /*#__PURE__*/ _jsx(Input, {
                placeholder: messages.placeholders.email,
                onChange: this.props.onSetFormValue
            })
        });
    }
    renderSendEmailInvitation() {
        if (this.props.isEnrolling) {
            return null;
        }
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(FormGroup, {
                    id: "sendEmailInvitation",
                    labelMessage: "",
                    formValues: this.props.formValues,
                    children: /*#__PURE__*/ _jsx(CheckboxRadio, {
                        inputValue: "true",
                        labelMessage: messages.labels.sendEmailInvitation,
                        onChange: this.props.onSetFormValue
                    })
                }),
                this.renderEmailField()
            ]
        });
    }
    renderPayer() {
        return /*#__PURE__*/ _jsx(FormGroup, {
            id: "payer",
            labelMessage: Account.messages.labels.payer,
            formValues: this.props.formValues,
            children: /*#__PURE__*/ _jsx(AutosuggestInput, {
                suggestions: this.props.payers,
                placeholder: Account.messages.placeholders.payer,
                onChange: this.props.onSetFormValue
            })
        });
    }
    renderTemplateField(fieldNames, optional = false) {
        const field = this.findTemplateFieldByName(fieldNames);
        if (!field || optional && field.isMandatory || !optional && !field.isMandatory) {
            return null;
        }
        return /*#__PURE__*/ _jsx(TemplatedFields, {
            template: [
                field
            ],
            disabledFields: this.disabledFields || [],
            formValues: this.props.formValues,
            messages: messages,
            localizationResources: this.props.localizationResources,
            validatorRules: this.validatorRules,
            onAddValidatorRules: (rules)=>this.onAddValidatorRules(rules),
            onSetFormValue: this.props.onSetFormValue,
            onSetFormValues: this.props.onSetFormValues
        });
    }
    renderMandatorySection(isDateOfBirthMandatory, isPayerMandatory) {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ _jsx(FormGroup, {
                            id: "firstName",
                            labelMessage: messages.labels.firstName,
                            className: "col-6",
                            formValues: this.props.formValues,
                            children: /*#__PURE__*/ _jsx(Input, {
                                placeholder: messages.placeholders.firstName,
                                onChange: (input)=>this.onChangeName(input)
                            })
                        }),
                        /*#__PURE__*/ _jsx(FormGroup, {
                            id: "lastName",
                            labelMessage: messages.labels.lastName,
                            className: "col-6",
                            formValues: this.props.formValues,
                            children: /*#__PURE__*/ _jsx(Input, {
                                placeholder: messages.placeholders.lastName,
                                onChange: (input)=>this.onChangeName(input)
                            })
                        })
                    ]
                }),
                this.renderSendEmailInvitation(),
                this.renderTemplateField('personalIdentifier'),
                isPayerMandatory && this.renderPayer(),
                isDateOfBirthMandatory && /*#__PURE__*/ _jsx(DateOfBirthFormPartial, {
                    formValues: this.props.formValues,
                    onSetFormValue: this.props.onSetFormValue
                }),
                this.renderTemplateField('phone'),
                this.renderTemplateField('otherInformation'),
                this.renderTemplateField('gender')
            ]
        });
    }
    renderOptionalSection(isDateOfBirthMandatory, isPayerMandatory) {
        const { isOptionalSectionOpen, isOptionalSectionOverflow } = this.state;
        return /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.optionalSection, {
                [styles['optionalSection--overflow']]: isOptionalSectionOverflow
            }),
            children: [
                /*#__PURE__*/ _jsxs("h3", {
                    className: styles.optionalSection__header,
                    onClick: (evt)=>this.onToggleOptionalSection(evt),
                    role: "presentation",
                    children: [
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.optionalInformation)),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn collapsible__btn",
                            onClick: (evt)=>this.onToggleOptionalSection(evt),
                            children: /*#__PURE__*/ _jsx(ChevronRight, {
                                className: cn('collapsible__btn__icon', {
                                    'collapsible__btn__icon--collapsed': isOptionalSectionOpen
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(motion.div, {
                    initial: {
                        height: 0,
                        overflow: 'hidden'
                    },
                    animate: {
                        height: isOptionalSectionOpen ? 'auto' : 0
                    },
                    transition: {
                        ease: 'easeOut',
                        duration: 0.15
                    },
                    onAnimationStart: ()=>this.onToggleOptionalSectionOverflow('start'),
                    onAnimationComplete: ()=>this.onToggleOptionalSectionOverflow('complete'),
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles.optionalSection__content,
                        children: [
                            this.renderTemplateField('phone', true),
                            this.renderTemplateField('otherInformation', true),
                            this.renderTemplateField('personalIdentifier', true),
                            !isPayerMandatory && this.renderPayer(),
                            this.renderTemplateField('gender', true),
                            !isDateOfBirthMandatory && /*#__PURE__*/ _jsx(DateOfBirthFormPartial, {
                                formValues: this.props.formValues,
                                onSetFormValue: this.props.onSetFormValue
                            }),
                            /*#__PURE__*/ _jsx(PhiSetFormPartial, {
                                metricConversions: this.metricConversions,
                                formValues: this.props.formValues,
                                onSetFormValue: this.props.onSetFormValue,
                                localizationResources: this.props.localizationResources,
                                isActiveProfileTypePwd: Account.constants.PROFILE_TYPES.PWD === this.props.activeProfileType,
                                isMale: get(this.props.formValues, 'values.gender') === 'Male',
                                isListInverted: true
                            })
                        ]
                    })
                })
            ]
        });
    }
    renderManual() {
        const { isDateOfBirthMandatory, isPayerMandatory } = this;
        return /*#__PURE__*/ _jsxs(Form, {
            onSubmit: ()=>this.onSubmit(),
            children: [
                /*#__PURE__*/ _jsx(AlertsBus, {
                    className: "mb-4"
                }),
                this.renderMandatorySection(isDateOfBirthMandatory, isPayerMandatory),
                this.renderOptionalSection(isDateOfBirthMandatory, isPayerMandatory),
                /*#__PURE__*/ _jsx("div", {
                    className: "modal__actions",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "primary",
                        type: "submit",
                        labelMessage: messages.buttons.addNewPatient,
                        className: "btn--block btn--filled",
                        isDisabled: this.isDisabled,
                        isInProgress: this.state.isInProgress,
                        onClickDisabled: ()=>this.onCheck()
                    })
                })
            ]
        });
    }
    renderQrContent() {
        const { domain } = this.context;
        const clientId = get(window, 'App.oidc.client_id');
        const { enrollCode, clinic } = this.props.activeClinicMembership;
        const { countryCode } = clinic;
        const { invitationCode } = this;
        const identityRequirements = {
            countryCode,
            scope: Account.constants.SCOPE_NAMES.PERSONAL,
            blsReturnUrl: `${domain}/setup?enrollCode=${enrollCode}&invitationCode=${invitationCode}&client_id=${clientId}`
        };
        const base64IdentityRequirements = btoa(JSON.stringify(identityRequirements));
        const url = `${domain}/aid/sign-up?identityRequirements=${base64IdentityRequirements}`;
        return /*#__PURE__*/ _jsx(QRCode, {
            value: url,
            size: 250
        });
    }
    renderQr() {
        return /*#__PURE__*/ _jsx("div", {
            className: "d-flex flex-column align-items-center",
            children: /*#__PURE__*/ _jsx("div", {
                className: "my-4",
                children: this.renderQrContent()
            })
        });
    }
    render() {
        if (!this.props.isHcpAccount) {
            return null;
        }
        if (this.props.isManualOnly) {
            return this.renderManual();
        }
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(Tabs, {
                    activeItem: this.state.view,
                    items: [
                        'manual',
                        'qrCode'
                    ],
                    messages: messages.nav,
                    action: (activeView)=>this.onChangeView(activeView)
                }),
                this.state.view === 'manual' ? this.renderManual() : this.renderQr()
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            view: 'manual',
            isDateOfBirthMandatory: false,
            isInProgress: false,
            isOptionalSectionOpen: false,
            isOptionalSectionOverflow: false
        };
        this.metricConversions = new MetricConversions(props.metricsUnits);
        this.invitationCode = uuid();
        this.patientId = null;
        this.validatorRules = addMetricUnitMaxValueRules(validatorRules, this.metricConversions);
        this.personalIdentifierFields = [];
        this.onDebouncedEnterName = debounce(()=>this.onEnterName(), 150);
        const countryId = get(props.activeClinicMembership, 'clinic.countryId');
        props.onFetchPatientCountryLocalization(countryId);
        props.onFetchPayers(countryId);
        this.onSetupPersonalIdentifier();
    }
}
_define_property(AddPatientForm, "contextType", AppContext);
_define_property(AddPatientForm, "propTypes", _object_spread_props(_object_spread({}, FormContainerAbstract.propTypes), {
    // Explicit props
    modalId: PropTypes.string,
    isAutoActivation: PropTypes.bool,
    isManualOnly: PropTypes.bool,
    isEnrolling: PropTypes.bool,
    // Explicit actions
    onClose: PropTypes.func,
    // Implicit props
    activeClinicMembership: Account.shapes.clinicMembership,
    receivedSharingRequest: shapes.sharingRequest,
    patients: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        invitationCode: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string
    })),
    isHcpAccount: PropTypes.bool,
    metricsUnits: PropTypes.object,
    clinicPatientTemplate: PropTypes.arrayOf(informationFieldShape),
    payers: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired
    })),
    localizationResources: PropTypes.object,
    openModalId: PropTypes.string,
    intl: intlShape,
    countrySettings: countrySettingsShape,
    isFetchPatientCountryLocalizationInProgress: PropTypes.bool,
    hasFetchPatientCountryLocalizationError: PropTypes.bool,
    activeProfileType: Account.shapes.profileType,
    // Implicit actions
    onCheckApprove: PropTypes.func,
    onBindWithClinicPatient: PropTypes.func,
    onStopCheckApprove: PropTypes.func,
    onUnsetReceivedSharingRequest: PropTypes.func,
    onFetchPatientCountryLocalization: PropTypes.func,
    onFetchPayers: PropTypes.func,
    onAddPayerProposal: PropTypes.func
}));
const mapStateToProps = ()=>{
    const getForm = App.selectors.formSelector(constants.INVITE_PATIENT_FORM);
    return (state)=>({
            activeClinicMembership: Account.selectors.activeClinicMembership(state),
            metricsUnits: Account.selectors.metricsUnits(state),
            isHcpAccount: Account.selectors.isHcpAccount(state),
            activeProfileType: Account.selectors.activeProfileType(state),
            patients: selectors.patients(state),
            isInProgress: selectors.isAddPatientInProgress(state),
            hasErrors: selectors.hasAddPatientErrors(state),
            receivedSharingRequest: selectors.receivedSharingRequest(state),
            countrySettings: selectors.countrySettings(state),
            clinicPatientTemplate: selectors.clinicPatientTemplate(state),
            payers: selectors.payers(state),
            isFetchPatientCountryLocalizationInProgress: selectors.isFetchPatientCountryLocalizationInProgress(state),
            hasFetchPatientCountryLocalizationError: selectors.hasFetchPatientCountryLocalizationErrors(state),
            localizationResources: App.selectors.localizationResources(state),
            openModalId: App.selectors.modal(state),
            formValues: getForm(state)
        });
};
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.INVITE_PATIENT_FORM;
    return {
        onSubmit: (patientValues, clinicMembership)=>dispatch(actions.addPatient(patientValues, clinicMembership)),
        onCheckApprove: (invitationCode, successAction)=>dispatch(actions.checkSharingRequestApprove(invitationCode, successAction)),
        onBindWithClinicPatient: (sharingRequest, clinicPatient, clinicMembership)=>dispatch(actions.bindSharingRequestWithClinicPatient(sharingRequest, clinicPatient, clinicMembership)),
        onUnsetReceivedSharingRequest: ()=>dispatch(actions.unsetReceivedSharingRequest()),
        onFetchPatientCountryLocalization: (countryId)=>dispatch(actions.fetchPatientCountryLocalization(countryId)),
        onFetchPayers: (countryId)=>dispatch(actions.fetchPayers(countryId)),
        onStopCheckApprove: ()=>dispatch(actions.stopCheckSharingRequestApprove()),
        onAddPayerProposal: (countryId, payer)=>dispatch(App.actions.addPayerProposal(countryId, payer)),
        // onCloseModal                 : () => dispatch(App.actions.closeModal()),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName)),
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onSetFormValues: (values)=>dispatch(App.actions.setFormValues(formName, values)),
        onUnsetFormValues: (ids)=>dispatch(App.actions.unsetFormValues(formName, ids)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onClearForm: ()=>dispatch(App.actions.clearForm(formName))
    };
};
const ConnectedAddPatientForm = connect(mapStateToProps, mapDispatchToProps)(injectIntl(AddPatientForm));
export default withStyles(styles)(ConnectedAddPatientForm);
